import PaymentCessionDialog from './PaymentCessionDialog';

export default PaymentCessionDialog;
